// Общие функции для администрирования полей регистрации (ParticipatorsMain).
// Используются вкладкой «Доп.Данные» и (в перспективе) модалом создания мероприятия.

export const getParticipatorsData = (ParticipatorsMain) => {
    const data = ParticipatorsMain && ParticipatorsMain.ParticipatorsData;
    return Array.isArray(data) ? data : [];
};

const normalizeField = (field) => ({
    name: String((field && field.name) || ''),
    title: (field && field.title) || '',
    type: (field && field.type) || 'select',
    isNecessery: !!(field && field.isNecessery),
    options: ((field && field.options) || []).map((option) => ({
        key: (option && option.key !== undefined && option.key !== null) ? String(option.key) : '',
        title: (option && option.title) || '',
    })),
});

const isSameField = (a, b) => {
    return JSON.stringify(normalizeField(a)) === JSON.stringify(normalizeField(b));
};

/**
 * Сравнивает старый и новый ParticipatorsData.
 * Возвращает { added, removed, changed } — массивы полей.
 */
export const getParticipatorsDiff = (oldData = [], newData = []) => {
    const oldMap = new Map((oldData || []).filter(x => x && x.name).map(x => [String(x.name), x]));
    const newMap = new Map((newData || []).filter(x => x && x.name).map(x => [String(x.name), x]));

    const added = (newData || []).filter(x => x && x.name && !oldMap.has(String(x.name)));
    const removed = (oldData || []).filter(x => x && x.name && !newMap.has(String(x.name)));
    const changed = (newData || []).filter(x => {
        if (!x || !x.name) return false;
        const oldField = oldMap.get(String(x.name));
        return !!oldField && !isSameField(oldField, x);
    });

    return { added, removed, changed };
};

/**
 * Создаёт PaymentMain с пустыми категориями по текущим полям регистрации.
 * Это тот же результат, который получается при создании мероприятия
 * (addEventModal.onParticipatorsData).
 */
export const buildPaymentMainFromParticipators = (ParticipatorsMain) => ({
    PaymentData: {
        participatorsCategorys: getParticipatorsData(ParticipatorsMain).map(({ name, title, options }) => ({
            name,
            title,
            options: (options || []).map(option => ({ ...option })),
            paymentSplit: false,
            payments: [],
        })),
        participatorsSales: [],
    },
});

const hasNonZeroPayment = (payment) => {
    if (!payment) return false;
    if (Number(payment.oncePayment) > 0) return true;
    const keysWithPayment = payment.keysWithPayment || {};
    return Object.keys(keysWithPayment).some(key => Number(keysWithPayment[key]) > 0);
};

/** Настроена ли у поля хоть одна ненулевая цена. */
export const hasPaymentForField = (PaymentMain, fieldName) => {
    const categorys = PaymentMain && PaymentMain.PaymentData && PaymentMain.PaymentData.participatorsCategorys;
    if (!Array.isArray(categorys)) return false;

    const category = categorys.find(x => String(x.name) === String(fieldName));
    if (!category || !Array.isArray(category.payments)) return false;

    return category.payments.some(hasNonZeroPayment);
};

/**
 * Точечно убирает категории оплаты удалённых полей (без полного сброса оплаты).
 * Используется, когда у мероприятия уже есть участники и удалять поле можно.
 */
export const removePaymentCategoriesForFields = (PaymentMain, removedFieldNames) => {
    if (!PaymentMain || !PaymentMain.PaymentData) return PaymentMain;

    const removedList = Array.isArray(removedFieldNames) ? removedFieldNames : [removedFieldNames];
    const removed = new Set(removedList.filter(Boolean).map(String));
    const categorys = Array.isArray(PaymentMain.PaymentData.participatorsCategorys)
        ? PaymentMain.PaymentData.participatorsCategorys
        : [];
    const kept = [];

    categorys.forEach((category, index) => {
        if (!removed.has(String(category.name))) kept.push({ category, index });
    });

    if (kept.length === categorys.length) return PaymentMain;

    const keptIndexes = new Set(kept.map(x => x.index));
    const sales = (PaymentMain.PaymentData.participatorsSales || []).map(sale => ({
        ...sale,
        options: (sale.options || []).filter((option, index) => keptIndexes.has(index)),
    }));

    return {
        ...PaymentMain,
        PaymentData: {
            ...PaymentMain.PaymentData,
            participatorsCategorys: kept.map(x => x.category),
            participatorsSales: sales,
        },
    };
};
